import * as Yup from 'yup';

export const optionValidationSchema = Yup.object({
  option_text_en: Yup.string()
    .required('English option text is required')
    .min(1, 'English option text is required'),
  option_text_fr: Yup.string()
    .required('French option text is required')
    .min(1, 'French option text is required'),
  option_image_en: Yup.string().url('Must be a valid URL').nullable(),
  option_image_fr: Yup.string().url('Must be a valid URL').nullable(),
  is_correct: Yup.boolean(),
  grading_data: Yup.object()
    .shape({
      teamId: Yup.number().nullable(),
      playerId: Yup.number().nullable(),
      playerName: Yup.string().nullable(),
      threshold: Yup.number().nullable(),
      comparison: Yup.string().oneOf(['over', 'under']).nullable(),
    })
    .nullable(),
});
